export enum TimeMode {
  Single = 'single',
  Range = 'range',
}

export enum GameStatus {
  'NewGame' = 'NewGame',
  'Level1' = 'Level1',
  'Level2' = 'Level2',
  'Level3' = 'Level3',
  'Summary' = 'Summary',
}

export enum Levels {
  'L1' = 'level1',
  'L2' = 'level2',
  'L3' = 'level3',
}

export enum Gender {
  'Man' = 'man',
  'Woman' = 'woman',
}

export enum TaskGameStatus {
  BeforeGame = 'BeforeGame',
  TimerInProgress = 'TimerInProgress',
  TimerPaused = 'TimerPaused',
  TimeEnd = 'TimeEnd',
}
